/** Busca (?aba=) da tela de Configurações: fica fora da tela para ela carregar sob demanda. */
export type BuscaConfiguracoes = {
  aba?:
    | "pessoas"
    | "distribuicao"
    | "atendimento"
    | "horario"
    | "automacoes"
    | "etiquetas"
    | "vendas"
    | "ia"
    | "respostas"
    | "integracoes"
    | "privacidade";
};
export const validarBuscaConfiguracoes = (s: Record<string, unknown>): BuscaConfiguracoes =>
  s["aba"] === "distribuicao" ||
  s["aba"] === "atendimento" ||
  s["aba"] === "horario" ||
  s["aba"] === "automacoes" ||
  s["aba"] === "etiquetas" ||
  s["aba"] === "vendas" ||
  s["aba"] === "ia" ||
  s["aba"] === "respostas" ||
  s["aba"] === "integracoes" ||
  s["aba"] === "privacidade"
    ? { aba: s["aba"] }
    : {};
